import 'jquery';
import { loadHeroVideo } from '../utils/video';
import { faqAccordion } from '../utils/faq';
import { screenshotsAccordion } from '../utils/screenshots';
import { triggerHighlightAnimations } from '../utils/animations';
import '../utils/slick.js';

document.addEventListener('DOMContentLoaded', function (e) {
  loadHeroVideo();
  faqAccordion();
  screenshotsAccordion();
  triggerHighlightAnimations();
});
$(function () {
  const blockBusinessCards = $('.block-business__cards.mobile');
  blockBusinessCards.slick({
    prevArrow: '<div class="arrow-left"></div>',
    nextArrow: '<div class="arrow-right"></div>',
    autoplay: true,
    autoplaySpeed: 8000,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    init: function (event, slick) {
      blockHeroLogos.find('.slick-slide').css('opacity', 0);
      blockHeroLogos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });

  var sections = $('.monitoring.hv2-monitoring .hv2-resources');

  sections.each(function () {
    var section = $(this);
    var slider = section.find('.hv2-resources__list');
    var resources = section.find('.hv2-resources__card');

    function initSlider() {
      slider.slick({
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              centerPadding: '10%'
            }
          }
        ]
      });
    }

    function destroySlider() {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
    }

    function removeSalAnimate() {
      resources.each(function () {
        $(this).removeClass('sal-animate');
        $(this).removeAttr('data-sal');
        $(this).removeAttr('data-sal-duration');
        $(this).removeAttr('data-sal-delay');
      });
    }

    function handleResize() {
      var isMobile = $(window).width() <= 991;

      if (isMobile && !slider.hasClass('slick-initialized')) {
        removeSalAnimate();
        initSlider();
      } else if (!isMobile && slider.hasClass('slick-initialized')) {
        destroySlider();
      }
    }

    handleResize();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        handleResize();
      }, 100);
    });
  });
});
